import React from 'react';
import { useSelector } from 'react-redux';
import * as s from './styled-cards-set-points';
import { icons } from '../../../../assets';

const SetPointCard = ({ variavel, value, changeValue, openModal }) => {

  const { user } = useSelector((state) => state.usuario);

  return (
    <s.Card key={variavel.id}>
      <s.Column style={{ justifyContent: 'space-evenly' }}>
        <s.Title>{variavel.setpoint.label}</s.Title>
        <s.Level>{variavel.setpoint.level || '-'}</s.Level>
        
        {/* {user.role !== "visualizador" &&  */}
        <s.ElevatedValue>
          <input
            type="number"
            value={value ? value.value : variavel.value}
            onChange={
                (e) => {
                  if(user.role !==  "visualizador") {
                    changeValue(variavel.setpoint.id, {
                      value: e.target.value,
                      name: variavel.setpoint.variable,
                    })
                  }
                }}
            disabled={user.role === "visualizador"}
          />
          {variavel.setpoint.unit}
        </s.ElevatedValue>
        {/* } */}
        <s.HistoricIconWrapper onClick={openModal} type="button">
          <img
            style={{ width: 15, height: 15 }}
            src={icons.MonitorCardiaco}
            alt=""
          />
        </s.HistoricIconWrapper>
      </s.Column>
    </s.Card>
  );
};

export default SetPointCard;
